import { render, staticRenderFns } from "./ListaEmpaque.vue?vue&type=template&id=3d196b17&"
import script from "./ListaEmpaque.vue?vue&type=script&lang=js&"
export * from "./ListaEmpaque.vue?vue&type=script&lang=js&"
import style0 from "./ListaEmpaque.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports